import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full flex flex-row" }
const _hoisted_2 = { class: "col-fit h-min bg-white p-3 border-round-2xl" }
const _hoisted_3 = { class: "list-none p-0" }
const _hoisted_4 = { class: "flex items-center border-bottom-2 border-100" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center border-bottom-2 border-100"
}
const _hoisted_6 = {
  key: 1,
  class: "flex border-bottom-2 border-100"
}
const _hoisted_7 = {
  key: 2,
  class: "flex border-bottom-2 border-100"
}
const _hoisted_8 = { class: "flex border-bottom-2 border-100" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = {
  key: 0,
  class: "col-8 p-0 ml-4"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { key: 5 }

import { RelayHub } from '@/views/Admin/Tenants/components';
import { onBeforeMount, onBeforeUnmount, ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { can, useMasterTenant, useRouting, useTenant } from '@/composables';
import { PERMISSIONS, TENANT_SETTINGS } from '@/enum';
import { useTenantIntegrationStore } from '@/store';
import Authentication from '@/views/Admin/Tenants/components/Integrations/Authentication';
import Quickbooks from '@/views/Admin/Tenants/components/Integrations/Quickbooks';
import UploadRSM from '@/views/Admin/Tenants/components/Integrations/UploadRSM';
import Screeners from '@/views/Admin/Tenants/components/Integrations/Screeners';
import StudentInformationSystem from '@/views/Admin/Tenants/components/Integrations/StudentInformationSystem';


export default /*@__PURE__*/_defineComponent({
  __name: 'Integrations',
  setup(__props) {

const tenantIntegrationStore = useTenantIntegrationStore();
const { integrations, initialLoading } = storeToRefs(tenantIntegrationStore);

const $routing = useRouting();

const currentView = ref('authentication');

const hasQuickbooksAccess = ref(false);

const tenantId = ref(0);

const isMasterTenant = computed(() => useMasterTenant().isMaster());

const $tenant = useTenant();

const isMasterTenantAndMedicaidEnabled = computed(
  () => !!isMasterTenant.value && $tenant.tenantSettingEnabled(TENANT_SETTINGS.MEDICAID_BILLING),
);

onBeforeMount(async () => {
  tenantId.value = Number($routing.route.params.id);

  if (!integrations.value.length && !initialLoading.value) {
    await tenantIntegrationStore.getRoles(tenantId.value);
    await tenantIntegrationStore.getUsers(tenantId.value);
    await tenantIntegrationStore.getTenantIntegrations(tenantId.value);
  }

  updateCurrentView();
  window.addEventListener('hashchange', updateCurrentView);
  if (isMasterTenant.value && can([PERMISSIONS.QUICKBOOKS])) hasQuickbooksAccess.value = true;
});

onBeforeUnmount(async () => (integrations.value = []));

const updateCurrentView = () => (currentView.value = window.location.hash.replace('#', '') || 'authentication');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: _normalizeClass(["p-3 font-semibold no-underline", currentView.value === 'authentication' ? 'text-color-green' : 'text-500']),
            href: "#authentication",
            textContent: 'Authentication'
          }, null, 2)
        ]),
        (isMasterTenantAndMedicaidEnabled.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _createElementVNode("a", {
                class: _normalizeClass(["p-3 font-semibold no-underline", currentView.value === 'relayhub' ? 'text-color-green' : 'text-500']),
                href: "#relayhub"
              }, " Medicaid (RelayHub) ", 2)
            ]))
          : _createCommentVNode("", true),
        (hasQuickbooksAccess.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _createElementVNode("a", {
                class: _normalizeClass(["p-3 font-semibold no-underline", currentView.value === 'quickbooks' ? 'text-color-green' : 'text-500']),
                href: "#quickbooks",
                textContent: 'Quickbooks'
              }, null, 2)
            ]))
          : _createCommentVNode("", true),
        (isMasterTenant.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
              _createElementVNode("a", {
                class: _normalizeClass(["p-3 font-semibold no-underline", currentView.value === 'rsm-upload' ? 'text-color-green' : 'text-500']),
                href: "#rsm-upload",
                textContent: 'RSM'
              }, null, 2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("a", {
            class: _normalizeClass(["p-3 font-semibold no-underline", currentView.value === 'screeners' ? 'text-color-green' : 'text-500']),
            href: "#screeners",
            textContent: 'Screeners (Resonant Ed)'
          }, null, 2)
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("a", {
            class: _normalizeClass(["p-3 font-semibold no-underline", currentView.value === 'sis' ? 'text-color-green' : 'text-500']),
            href: "#sis",
            textContent: 'Student Information Systems (SIS)'
          }, null, 2)
        ])
      ])
    ]),
    (!_unref(initialLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (currentView.value === 'quickbooks' && hasQuickbooksAccess.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_unref(Quickbooks))
              ]))
            : (currentView.value === 'authentication')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_unref(Authentication))
                ]))
              : (currentView.value === 'rsm-upload' && isMasterTenant.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_unref(UploadRSM))
                  ]))
                : (currentView.value === 'relayhub' && isMasterTenantAndMedicaidEnabled.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_unref(RelayHub))
                    ]))
                  : (currentView.value === 'screeners')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_unref(Screeners))
                      ]))
                    : (currentView.value === 'sis')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_unref(StudentInformationSystem))
                        ]))
                      : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})